import { render, staticRenderFns } from "./AngleRightSvg.vue?vue&type=template&id=7833a7d2&scoped=true&"
import script from "./AngleRightSvg.vue?vue&type=script&lang=js&"
export * from "./AngleRightSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7833a7d2",
  null
  
)

export default component.exports